// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__xOsA+","avatarImage":"Avatar_avatarImage__QmhdL","avatarFallback":"Avatar_avatarFallback__593Uw"};